import React from 'react';
import get from 'lodash/get';
import { Link } from 'react-router-dom';
// import {I18NUrl} from './App';
import OnVisible, { setDefaultProps } from 'react-on-visible';

setDefaultProps({
  bounce: true,
  visibleClassName: 'is-visible',
  percent: 10,
});

class FeaturedProjects extends React.Component {
  render() {
    const items = this.props.featured && this.props.featured.map((uid) => {
        const project = this.props.projects[uid];

        if (!project) {
          return null;
        }

        const img = project.getImage('project.thumbnail');

        return (
          <div
                key={uid}
                className="featured-project"
              >
            <OnVisible className="featured-project-container">
              <div className="featured-project-wrapper">
                <div className="featured-project__image">
                  <Link to={`/${this.props.currentLang}/projects/${uid}`}>
                    <img
                      src={img.main.url}
                      width={img.main.width}
                      height={img.main.height}
                      alt={img.main.alt}
                      srcSet={`${img.main.url} ${img.main.width}w, \
                        ${get(img, 'views.2x.url')} ${get(img, 'views.2x.width')}w, \
                        ${get(img, 'views.4x.url')} ${get(img, 'views.4x.width')}w`}
                    />
                  </Link>
                </div>
                <div className="featured-project__details">
                  {project.getText('project.category')}
                  <span
                    dangerouslySetInnerHTML={{ __html: project.getText('project.title') }}
                    style={{ color: project.getColor('project.color') }}
                  />
                </div>
              </div>
            </OnVisible>
          </div>
        )
      });

    return (
      <section id="featured-projects" className="featured-projects">
        <h2 className="sr-only">Featured Projects</h2>
        <div className="featured-projects__items">
          {items}
        </div>
      </section>
    );
  }
}

export default FeaturedProjects;



// WEBPACK FOOTER //
// ./src/components/FeaturedProjects.js